import React, { createContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
  marcarDestaqueLido,
  marcarNoticiaLido,
  marcarVideosLido,
  marcarFaseLido,
  marcarFotoLido,
  marcarNotificacoesComoExibidas,
  marcarNotificacaoFinanceiroComoLida,
  marcarNotificacaoAgendamento,
  marcarNotificacaoVistoriaNaoCompareceu,
  marcarNotificacaoAniversario,
  marcarNotificacaoManutencaoPeriodica,
  marcarNotificacaoContratoFinanciamentoLida,
} from "./marcarNotificacaoLida";

import {
  getAllNotifications,
  getNotifDestaques,
  getNotifNoticias,
  getNotifVideos,
  getNotifFase,
  getNotifFotos,
  getParcelasPendentes,
  getParcelasVencidas,
  getAgendamentosAbertos,
  getAniversarioNotificacao,
  getVistoriaNaoCompareceu,
  getNotificationHistoric,
  getBoletosVencidos,
  getUrlFotoS3,
} from "./endPointsNotificacoes";

const ContextNotificacoes = createContext();

function Notificacoes({ children }) {
  const [notificationNotFoundError, setNotificationNotFoundError] =
    useState(false);

  const [notificacoes, setNotificacoes] = useState(null);

  const [mostraSinoNotificacoes, setMostraSinoNotificacoes] = useState(false);

  const [novaNotificacao, setNovaNotificacao] = useState(null);

  const [openSurveyModal, setOpenSurveyModal] = useState(false);
  const [surveyModal, setSurveyModal] = useState(null);
  const history = useHistory();

  const handleNotificationError = () => {
    setNotificationNotFoundError(true);
    history.push("/interna");
  };

  useEffect(() => {
    CHECKIFNOTIFICATION();
  }, []);

  function loadSessionStorage(name, data) {
    if (!data) {
      // totalNotifications += 0;
      sessionStorage.setItem(name, JSON.stringify([]));
    } else {
      // totalNotifications += data?.length;
      sessionStorage.setItem(name, JSON.stringify(data));
    }
    // setLoadingNotificacoes(loadNotificacoes);
    // sessionStorage.setItem("totalNotificacoes", totalNotifications);
  }

  async function getBoletosNotif() {
    let resultGet = [];
    try {
      let res = await getNotificationHistoric();
      resultGet = res.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsBoletos", resultGet);
  }

  async function getBoletosVencidosNotif() {
    let resultGet = [];
    try {
      let res = await getBoletosVencidos();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsBoletosVencidos", resultGet);
  }

  async function getDestaquesNotif() {
    let resultGet = [];
    try {
      let res = await getNotifDestaques();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }

    loadSessionStorage("notificationsDestaques", resultGet);
  }

  async function getNoticiasNotif() {
    let resultGet = [];
    try {
      let res = await getNotifNoticias();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsNoticias", resultGet);
  }

  async function getVideosNotif() {
    let resultGet = [];
    try {
      let res = await getNotifVideos();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsVideos", resultGet);
  }

  async function getFaseNotif() {
    let resultGet = [];
    try {
      let res = await getNotifFase();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsFase", resultGet);
  }

  async function getFotosNotif() {
    let resultGet = [];
    try {
      let res = await getNotifFotos();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsFotos", resultGet);
  }

  async function getFotoUrlS3(IdAws) {
    if (IdAws) {
      try {
        let res = await getUrlFotoS3(IdAws);

        return res?.data;
      } catch (error) {
        console.error(error);
        return "data:,";
      }
    }
  }

  async function getAgendamentos() {
    let resultGet = [];
    try {
      let res = await getAgendamentosAbertos();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("agendamentos", resultGet);
  }

  async function getAniversario() {
    let resultGet = [];
    try {
      let res = await getAniversarioNotificacao();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsAniversario", resultGet);
  }

  // função que faz o get e pega as vistorias que o cliente não compareceu
  async function getVistoria() {
    let resultGet = [];
    try {
      let res = await getVistoriaNaoCompareceu();
      resultGet = res?.data;
    } catch (error) {
      resultGet = [];
    }
    loadSessionStorage("notificationsVistoriaNaoCompareceu", resultGet);
  }

  async function loadNotificacoes() {
    let resultGetAllNotifications = {};
    try {
      resultGetAllNotifications = await getAllNotifications();
      setNotificacoes(resultGetAllNotifications);
    } catch (error) {
      return [];
    }

    let getAll = resultGetAllNotifications?.data;

    if (
      getAll?.Agendamentos?.Errors == null &&
      getAll?.Agendamentos?.NotificacoesAgendamentos
    ) {
      loadSessionStorage(
        "agendamentos",
        getAll?.Agendamentos?.NotificacoesAgendamentos
      );
    } else getAgendamentos();

    if (
      getAll?.ParcelasPendentes?.Errors == null &&
      getAll?.ParcelasPendentes?.NotificacoesParcelasPendentes
    ) {
      loadSessionStorage(
        "notificationsParcelasPendentes",
        getAll?.ParcelasPendentes?.NotificacoesParcelasPendentes
      );
    } else getParcelasPendentes();

    if (
      getAll?.ParcelasVencidas?.Errors == null &&
      getAll?.ParcelasVencidas?.NotificacoesParcelasVencidos
    ) {
      loadSessionStorage(
        "notificationsParcelasVencidas",
        getAll?.ParcelasVencidas?.NotificacoesParcelasVencidos
      );
    } else getParcelasVencidas();

    if (
      getAll?.AtualizacaoFotos?.Errors == null &&
      getAll?.AtualizacaoFotos?.NotificacoesAtualizacaoFotos
    ) {
      loadSessionStorage(
        "notificationsFotos",
        getAll?.AtualizacaoFotos?.NotificacoesAtualizacaoFotos
      );
    } else getFotosNotif();

    if (
      getAll?.BoletosPendentes?.Errors == null &&
      getAll?.BoletosPendentes?.NotificacoesBoletosPendentes
    ) {
      loadSessionStorage(
        "notificationsBoletos",
        getAll?.BoletosPendentes?.NotificacoesBoletosPendentes
      );
    } else getBoletosNotif();

    if (
      getAll?.BoletosVencidos?.Errors == null &&
      getAll?.BoletosVencidos?.NotificacoesBoletosVencidos
    ) {
      loadSessionStorage(
        "notificationsBoletosVencidos",
        getAll?.BoletosVencidos?.NotificacoesBoletosVencidos
      );
    } else getBoletosVencidosNotif();

    if (
      getAll?.Destaques?.Errors == null &&
      getAll?.Destaques?.NotificacoesDestaques
    ) {
      let temp = getAll?.Destaques?.NotificacoesDestaques.filter((destaq) => {
        if (!destaq.Visualizado) return true;
        else return false;
      });

      loadSessionStorage("notificationsDestaques", temp);
    } else if (!getAll?.Destaques?.Errors) getDestaquesNotif();

    if (
      getAll?.Noticias?.Errors == null &&
      getAll?.Noticias?.NotificacoesNoticias
    ) {
      loadSessionStorage(
        "notificationsNoticias",
        getAll?.Noticias?.NotificacoesNoticias
      );
    } else getNoticiasNotif();

    if (
      getAll?.SolicitacaoFase?.Errors == null &&
      getAll?.SolicitacaoFase?.NotificacoesSolicitacaoFase
    ) {
      loadSessionStorage(
        "notificationsFase",
        getAll?.SolicitacaoFase?.NotificacoesSolicitacaoFase
      );
    } else getFaseNotif();

    if (getAll?.Videos?.Errors == null && getAll?.Videos?.NotificacoesVideos) {
      loadSessionStorage(
        "notificationsVideos",
        getAll?.Videos?.NotificacoesVideos
      );
    } else getVideosNotif();

    if (
      getAll?.Aniversario?.Errors == null &&
      getAll?.Aniversario?.NotificacoesAniversarios
    ) {
      loadSessionStorage(
        "notificationsAniversario",
        getAll?.Aniversario?.NotificacoesAniversarios
      );
    } else getAniversario();

    if (
      getAll?.SolicitacaoConcluida?.Errors == null &&
      (getAll?.SolicitacaoConcluida?.NotificacoesSolicitacaoConcluida ||
        getAll?.ContratoFinanciamento?.NotificacoesContratoFinanciamento)
    ) {
      const NOTIFICACOES_CONTRATO_FINANCIAMENTO =
        getAll?.ContratoFinanciamento?.NotificacoesContratoFinanciamento?.filter(
          (n) => n.GeraPesquisaSatisfacao
        )?.map((p) => {
          return {
            ...p,
            TipoPesquisaSatisfacao: "Contrato de Financiamento",
            Grupo: "FINANCIAMENTO",
            Subgrupo: "CONTRATO_FINANCIAMENTO_PREENCHIDO",
          };
        });

      const notificacoesPesquisa = [
        ...getAll?.SolicitacaoConcluida?.NotificacoesSolicitacaoConcluida,
        ...NOTIFICACOES_CONTRATO_FINANCIAMENTO,
      ];
      loadSessionStorage("notificationsPesquisa", [...notificacoesPesquisa]);

      showSurveyModal(notificacoesPesquisa);
    }

    // getAll?.notificacaoContrato
    if (
      getAll?.VistoriaNaoCompareceu?.Errors == null &&
      getAll?.VistoriaNaoCompareceu?.NotificacoesVistoriaNaoCompareceu
    ) {
      loadSessionStorage(
        "notificationsVistoriaNaoCompareceu",
        getAll?.VistoriaNaoCompareceu?.NotificacoesVistoriaNaoCompareceu
      );
    } else getVistoria();

    if (
      getAll?.ManutencaoPeriodica?.Errors == null &&
      getAll?.ManutencaoPeriodica?.NotificacoesManutencaoPeriodica
    ) {
      loadSessionStorage(
        "notificationsManutencaoPeriodica",
        getAll?.ManutencaoPeriodica?.NotificacoesManutencaoPeriodica
      );
    }
    if (
      getAll?.ContratoFinanciamento?.Errors == null &&
      getAll?.ContratoFinanciamento?.NotificacoesContratoFinanciamento
    ) {
      loadSessionStorage(
        "notificacoesContratoFinanciamento",
        getAll?.ContratoFinanciamento?.NotificacoesContratoFinanciamento
      );
    }
    // else getVistoria();
  }

  var NOTIFICATIONSBOLETOS = JSON.parse(
    sessionStorage.getItem("notificationsBoletos")
  );

  var NOTIFICATIONSBOLETOSVENCIDOS = JSON.parse(
    sessionStorage.getItem("notificationsBoletosVencidos")
  );

  var NOTIFICATIONSDESTAQUES = JSON.parse(
    sessionStorage.getItem("notificationsDestaques")
  );

  var NOTIFICATIONSVIDEOS = JSON.parse(
    sessionStorage.getItem("notificationsVideos")
  );

  var NOTIFICATIONSFOTOS = JSON.parse(
    sessionStorage.getItem("notificationsFotos")
  );

  var NOTIFICATIONSNOTICIAS = JSON.parse(
    sessionStorage.getItem("notificationsNoticias")
  );

  var NOTIFICATIONSAGENDAMENTOS = JSON.parse(
    sessionStorage.getItem("agendamentos")
  );

  var NOTIFICATIONSPARCELAS = JSON.parse(
    sessionStorage.getItem("notificationsParcelasPendentes")
  );

  var NOTIFICATIONSPARCELASVENCIDAS = JSON.parse(
    sessionStorage.getItem("notificationsParcelasVencidas")
  );

  var NOTIFICATIONSFASES = JSON.parse(
    sessionStorage.getItem("notificationsFase")
  );

  var NOTIFICATIONSANIVERSARIO = JSON.parse(
    sessionStorage.getItem("notificationsAniversario")
  );

  var NOTIFICATIONSVISTORIANAOCOMPARECEU = JSON.parse(
    sessionStorage.getItem("notificationsVistoriaNaoCompareceu")
  );

  var NOTIFICATIONSMANUTENCAOPERIODICA = JSON.parse(
    sessionStorage.getItem("notificationsManutencaoPeriodica")
  );

  var NOTIFICATIONSPESQUISA = JSON.parse(
    sessionStorage.getItem("notificationsPesquisa")
  );

  let NOTIFICATIONS_CONTRATO_FINANCIAMENTO = JSON.parse(
    sessionStorage.getItem("notificacoesContratoFinanciamento")
  );

  const showSurveyModal = (pesquisas) => {
    if (pesquisas?.length > 0) {
      for (let pesquisa of pesquisas) {
        if (!pesquisa?.Exibido) {
          setSurveyModal(pesquisa);
          setOpenSurveyModal(true);
          break;
        }
      }
    }
  };

  // função que será executada na home, quando for executado o getAll de notificações
  const CHECKIFNOTIFICATIONHOME = (todasNotificacoes) => {
    if (
      todasNotificacoes?.Agendamentos?.NotificacoesAgendamentos?.length ||
      todasNotificacoes?.AtualizacaoFotos?.NotificacoesAtualizacaoFotos
        ?.length ||
      todasNotificacoes?.Destaques?.NotificacoesDestaques?.length ||
      todasNotificacoes?.BoletosPendentes?.NotificacoesBoletosPendentes
        ?.length ||
      todasNotificacoes?.BoletosVencidos?.NotificacoesBoletosVencidos?.length ||
      todasNotificacoes?.ParcelasPendentes?.NotificacoesParcelasPendentes
        ?.length ||
      todasNotificacoes?.ParcelasVencidas?.NotificacoesParcelasVencidos
        ?.length ||
      todasNotificacoes?.Noticias?.NotificacoesNoticias?.length ||
      todasNotificacoes?.SolicitacaoFase?.NotificacoesSolicitacaoFase?.length ||
      todasNotificacoes?.Videos?.NotificacoesVideos?.length ||
      todasNotificacoes?.Aniversario?.NotificacoesAniversarios?.length ||
      todasNotificacoes?.VistoriaNaoCompareceu
        ?.NotificacoesVistoriaNaoCompareceu?.length ||
      todasNotificacoes?.SolicitacaoConcluida?.NotificacoesSolicitacaoConcluida
        ?.length ||
      todasNotificacoes?.ContratoFinanciamento
        ?.NotificacoesContratoFinanciamento?.length
    ) {
      // showSurveyModal(NOTIFICATIONSPESQUISA);
      setMostraSinoNotificacoes(true);
    } else setMostraSinoNotificacoes(false);

    if (
      verificaSeNotificacaoExibida(
        todasNotificacoes?.Agendamentos?.NotificacoesAgendamentos
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.AtualizacaoFotos?.NotificacoesAtualizacaoFotos
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.Destaques?.NotificacoesDestaques
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.BoletosPendentes?.NotificacoesBoletosPendentes
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.BoletosVencidos?.NotificacoesBoletosVencidos
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.ParcelasPendentes?.NotificacoesParcelasPendentes
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.ParcelasVencidas?.NotificacoesParcelasVencidos
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.Noticias?.NotificacoesNoticias
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.SolicitacaoFase?.NotificacoesSolicitacaoFase
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.Videos?.NotificacoesVideos
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.Aniversario?.NotificacoesAniversarios
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.VistoriaNaoCompareceu
          ?.NotificacoesVistoriaNaoCompareceu
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.VistoriaNaoCompareceu
          ?.NotificacoesVistoriaNaoCompareceu
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.SolicitacaoConcluida
          ?.NotificacoesSolicitacaoConcluida
      )?.length ||
      verificaSeNotificacaoExibida(
        todasNotificacoes?.ContratoFinanciamento
          ?.NotificacoesContratoFinanciamento
      )?.length
    ) {
      setNovaNotificacao(true);
    } else setNovaNotificacao(false);
  };

  // função que será executada em todas outras partes do sistemaira "pegar" os dados do local storage
  const CHECKIFNOTIFICATION = () => {
    if (
      NOTIFICATIONSBOLETOS?.length ||
      NOTIFICATIONSBOLETOSVENCIDOS?.length ||
      NOTIFICATIONSDESTAQUES?.length ||
      NOTIFICATIONSVIDEOS?.length ||
      NOTIFICATIONSFOTOS?.length ||
      NOTIFICATIONSNOTICIAS?.length ||
      NOTIFICATIONSAGENDAMENTOS?.length ||
      NOTIFICATIONSPARCELAS?.length ||
      NOTIFICATIONSPARCELASVENCIDAS?.length ||
      NOTIFICATIONSFASES?.length ||
      NOTIFICATIONSANIVERSARIO?.length ||
      NOTIFICATIONSVISTORIANAOCOMPARECEU?.length ||
      NOTIFICATIONSMANUTENCAOPERIODICA?.length ||
      NOTIFICATIONSPESQUISA?.length ||
      NOTIFICATIONS_CONTRATO_FINANCIAMENTO?.length
    ) {
      setMostraSinoNotificacoes(true);

      // showSurveyModal(NOTIFICATIONSPESQUISA);
    } else setMostraSinoNotificacoes(false);

    // if (NOTIFICATIONSPESQUISA?.length && !NOTIFICATIONSPESQUISA[0]?.Exibido)
    //   setSurveyModal(true);

    if (
      verificaSeNotificacaoExibida(NOTIFICATIONSBOLETOS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSBOLETOSVENCIDOS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSDESTAQUES)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSVIDEOS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSFOTOS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSNOTICIAS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSAGENDAMENTOS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSPARCELAS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSPARCELASVENCIDAS)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSFASES)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSANIVERSARIO)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSVISTORIANAOCOMPARECEU)
        ?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSMANUTENCAOPERIODICA)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONSPESQUISA)?.length ||
      verificaSeNotificacaoExibida(NOTIFICATIONS_CONTRATO_FINANCIAMENTO)?.length
    ) {
      setNovaNotificacao(true);
    } else setNovaNotificacao(false);
  };

  function verificaSeNotificacaoExibida(arrayNotificacoes) {
    let temp = arrayNotificacoes?.filter(
      (notificacao) => notificacao.Exibido === false
    );

    if (temp?.length > 0) {
      setNovaNotificacao(true);
    } else setNovaNotificacao(false);
    return temp;
  }

  // função para quando o usuário clicar em visualizar uma notificação, para desabilitar o sino caso seja a única notificação
  const atualizaNotificacoes = async () => {
    await loadNotificacoes();

    // let temp = await getAllNotifications();
    CHECKIFNOTIFICATIONHOME(notificacoes?.data);
  };

  return (
    <ContextNotificacoes.Provider
      value={{
        getNotificationHistoric,
        getBoletosVencidos,
        getNotifDestaques,
        getNotifNoticias,
        getNotifVideos,
        getNotifFase,
        getNotifFotos,
        getFotoUrlS3,
        getParcelasPendentes,
        getParcelasVencidas,
        getAniversarioNotificacao,
        getVistoriaNaoCompareceu,
        marcarDestaqueLido,
        marcarNoticiaLido,
        marcarVideosLido,
        marcarFaseLido,
        marcarFotoLido,
        marcarNotificacoesComoExibidas,
        marcarNotificacaoFinanceiroComoLida,
        marcarNotificacaoAgendamento,
        marcarNotificacaoVistoriaNaoCompareceu,
        marcarNotificacaoAniversario,
        marcarNotificacaoManutencaoPeriodica,
        marcarNotificacaoContratoFinanciamentoLida,
        notificationNotFoundError,
        setNotificationNotFoundError,
        loadNotificacoes,
        getAllNotifications,
        handleNotificationError,
        notificacoes,
        mostraSinoNotificacoes,
        novaNotificacao,
        CHECKIFNOTIFICATION,
        CHECKIFNOTIFICATIONHOME,
        NOTIFICATIONSFOTOS,
        NOTIFICATIONSDESTAQUES,
        NOTIFICATIONSNOTICIAS,
        NOTIFICATIONSVIDEOS,
        NOTIFICATIONSFASES,
        NOTIFICATIONSAGENDAMENTOS,
        NOTIFICATIONSBOLETOS,
        NOTIFICATIONSBOLETOSVENCIDOS,
        NOTIFICATIONSPARCELAS,
        NOTIFICATIONSPARCELASVENCIDAS,
        NOTIFICATIONSANIVERSARIO,
        NOTIFICATIONSVISTORIANAOCOMPARECEU,
        NOTIFICATIONSMANUTENCAOPERIODICA,
        NOTIFICATIONSPESQUISA,
        NOTIFICATIONS_CONTRATO_FINANCIAMENTO,
        setNovaNotificacao,
        atualizaNotificacoes,
        surveyModal,
        setSurveyModal,
        openSurveyModal,
        setOpenSurveyModal,
      }}
    >
      {children}
    </ContextNotificacoes.Provider>
  );
}

export { Notificacoes, ContextNotificacoes };
